<template>
    <popup :show="true" width="636px" @on-close="onClose">
        <div class="create-folder">
            <div class="create-folder-title">文件重命名</div>
            <div class="create-form-label">团队文件</div>
            <div class="create-form-input">
                <input type="text" placeholder="文件名称" v-model="file_name" />
            </div>
            <div class="permission-btn-box">
                <div class="btn-box">
                    <div class="btn" @click="onClose">取消</div>
                    <div class="btn" @click="onFileRename">确定</div>
                </div>
            </div>
        </div>
    </popup>
</template>
<script>
import { teamFileUpdate } from '@/api/index';
import Popup from '@/components/Popup.vue';
export default{
    name:"FileRename",
    components:{
        Popup
    },
    props:{
        teamId:{
            type:String,
            default:''
        },
        fileInfo:{
            type:Object,
            default:()=>({})
        },
    },
    data(){
        return{
            file_name:'',
        }
    },
    mounted(){
        this.file_name = this.fileInfo.name;
    },
    methods:{
        async onFileRename(){
            try{
                const param = {};
                param.team_uuid = this.teamId;
                param.file_uuid = this.fileInfo.uuid;
                param.type = this.fileInfo.type;
                param.info = {...this.fileInfo.info,name:this.file_name};
                console.log('param-file-rename',param);
                const {code,msg} = await teamFileUpdate(param);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('操作成功~');
                this.$emit('on-file-rename');
                this.onClose();
            }catch(e){
                console.log('err-create-folder',e);
            }
        },
        onClose(){
            this.$emit('on-close');
        }
    }
}
</script>
<style lang="scss" scoped>
    .create-folder{
        width:100%;
        border-radius:15px;
        background:#ffffff;
        padding:30px 50px;
        display:flex;
        flex-direction:column;
        .create-folder-title{
            color:#1a1a1a;
            font-size:24px;
            font-weight:bold;
        }
        .create-form-label{
            margin-top:30px;
            color:#666666;
            font-size:14px;
        }
        .create-form-input{
            width:100%;
            height:52px;
            border-radius:5px;
            border:1px solid #2254f4;
            padding:0 20px;
            margin-top:20px;
            input{
                width:100%;
                height:100%;
                border:none;
                outline:none;
            }
        }
        .permission-btn-box{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:space-between;
            margin-top:50px;
            .permission{
                display:flex;
                align-items:center;
                color:#666666;
                font-size:14px;
                .permission-box{
                    display:flex;
                    flex-direction:column;
                    .permission-item{
                        display:flex;
                        align-items:center;
                        column-gap:9px;
                        height:46px;
                        cursor:pointer;
                        &:hover{
                            background:#f7f7f7;
                        }
                        .selected-icon{
                            color: #f75664;
                        }
                    }
                }
            }
            .btn-box{
                display:flex;
                align-items:center;
                column-gap:9px;
                .btn{
                    width:110px;
                    height:32px;
                    border-radius:6px;
                    background:#ffffff;
                    border:1px solid #dedee0;
                    line-height:32px;
                    text-align:center;
                    cursor:pointer;
                    color:#4d4d4d;
                    font-size:14px;
                    &:last-child{
                        color:#ffffff;
                        background:#ff5967;
                        border:none;
                    }
                }
            }
        }
    }
</style>
